export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "welcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hola"])},
          "logout_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salir"])}
        }
      },
      "en": {
        "labels": {
          "welcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hello"])},
          "logout_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log out"])}
        }
      }
    }
  })
}